<a href="https://www.instagram.com/quizzaro_com/"
    ><span><img src="../../../assets/image/insta.png" alt="instagram icon" srcset="" /></span
></a>
